import React from "react";
import "./value.css";

const Value = () => {
  return (
    <>
      <div className="value-container">
        <div className="left md:basis-1/3">
          <h1>Why Choose Owision?</h1>
        </div>
        <div className="right md:basis-2/3">
          <p>
            Premium software. Precise deadlines. Perfect budgets. Our AI-powered teams in Stockholm
            combine cutting-edge tech with office-fueled collaboration to deliver unmatched value.
            Scale smarter with our flexible model.
          </p>
        </div>
      </div>
      <hr
        style={{
          width: "85%",
          marginTop: "0.5rem",
          marginBottom: "0.5rem",
          marginLeft: "auto",
          marginRight: "auto",
          border: "1px solid rgb(255, 255, 255)",
        }}
      />
    </>
  );
};

export default Value;
